export default {
  onlineStatus: Object.freeze({IS_ONLINE_LOCAL_STORAGE_KEY: 'is-online'}),
}
